<template>
    <v-dialog
        v-model="isProductBulkDialog"
        width="800px"
        @click:outside="init"
    >
    <v-card>
    <v-card-text>
    <div class="d-flex flex-wrap justify-center justify-md-space-between gap-4 mb-6">
      <div class="d-flex flex-column justify-center">
        <h4 class="text-h4">
          Upload SKU Images
        </h4>
        <template v-for="(errorItem, index) in warning">
            <li v-if="Object.keys(errorItem).length > 0" :key="index">
                <ul>
                    <li v-for="(messages, field) in errorItem" :key="field">
                        <span class="warning--text">{{ messages }}</span>
                        
                    </li>
                </ul>
            </li>
        </template>
      </div>

      <div class="d-flex gap-4 align-center flex-wrap">
        <v-btn
          outlined
          color="secondary"
          class="mr-2"
          @click="init"
        >
          Discard
        </v-btn>
        <v-btn
          outlined
          color="primary"
          :loading="loadProductData"
          @click="uploadImages"
          :disabled="!fileData.length || fileData.length > 15"
        >
          Upload Images
        </v-btn>
      </div>
    </div>

    <v-row>
        <v-col md="12">

            <!-- 👉 Product Image -->
            <v-card class="mb-6">
                <v-card-text>
                    <template #title>
                    Products Images
                    </template>
                    <template #append>
                    <div class="text-primary font-weight-medium cursor-pointer">
                        Add Media from URL
                    </div>
                    </template>
                </v-card-text>

                <v-card-text>
                    <div class="flex">
                        <div class="w-full h-auto relative">
                        <div
                            ref="dropZoneRef"
                        >
                            <div v-if="fileData.length === 0"
                            class="d-flex flex-column justify-center align-center gap-y-2 pa-2 drop-zone rounded cursor-pointer"
                            @click="() => openFile()"
                            >
                            <v-btn
                                oulined
                                color="secondary"
                                class="rounded"
                                size="30"
                            >
                                <v-icon
                                size="24"
                                >{{ icons.mdiTrayArrowUp }}</v-icon>
                            </v-btn>
                            <span class="text-h6">
                                Click to upload you product files here.
                            </span>

                            </div>

                            <div v-else class="drop-zone"
                            >
                                <v-row class="match-height w-100">
                                    <v-col
                                        cols="12"
                                        sm="4"
                                        v-for="(item, index) in fileData"
                                        :key="index"
                                    >
                                        <v-card >
                                        <v-card-text
                                            class="d-flex flex-column cursor-pointer"
                                            flat
                                            @click="editProduct(item.file.name)"
                                        >
                                            <SecureImage
                                            :src="`${item.url}`"
                                            contain
                                            width="200px"
                                            height="150px"
                                            class="w-100 mx-auto"
                                            />
                                            <div class="mt-2">
                                            <span class="clamp-text text-wrap">
                                                {{ item.file.name }}
                                            </span>
                                            <span>
                                                {{ item.file.size / 1000 }} KB
                                            </span>
                                            </div>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-select
                                            v-model="item.side"
                                            :items="imageSides"
                                            label="Side"
                                            placeholder="Select Side"
                                            outlined
                                            dense
                                            hide-details
                                            @click.stop
                                            >
                                            </v-select>
                                        </v-card-actions>
                                        <v-card-actions>
                                            <v-btn
                                            text
                                            @click.stop="fileData.splice(index, 1); warning = []"
                                            >
                                            Remove File
                                            </v-btn>
                                        </v-card-actions>
                                        </v-card>
                                    </v-col>
                                </v-row>

                            </div>
                        </div>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-col>

    </v-row></v-card-text>
  </v-card>
  <product
    :productDialog.sync="editDialog"
    :product="product"
    @save="saveProduct"
  >

  </product>
    <v-dialog v-model="isResolveDialogOpen" max-width="900px" persistent>
    <v-card>
        <v-card-title class="d-flex align-center">
        Confirm product matches
        <v-spacer />
        <v-chip small :color="resolveAllDone ? 'success' : 'warning'">
            {{ resolveConfirmations.length }} / {{ needsConfirmationImages.length }} resolved
        </v-chip>
        </v-card-title>

        <v-card-subtitle class="pt-1 pb-0">
        These images had a partial UPC match. Confirm the correct product for each.
        </v-card-subtitle>

        <v-card-text class="pt-4">
        <div v-for="item in needsConfirmationImages" :key="item.name" class="mb-2">
            <v-card outlined :class="{
            'border-success': !!resolveDecisions[item.name],
            'border-warning': !resolveDecisions[item.name],
            }">
            <div class="d-flex align-center px-4 py-3 cursor-pointer" @click="toggleResolveItem(item.name)">
                <div class="d-flex flex-column">
                <span class="text-body-2 font-weight-medium">{{ item.name }}</span>
                <span class="text-caption grey--text">UPC in filename: {{ item.original_barcode }}</span>
                </div>
                <v-spacer />
                <v-chip v-if="resolveDecisions[item.name]" x-small color="success" class="mr-2">
                Confirmed
                </v-chip>
                <v-chip v-else x-small color="warning" class="mr-2">Pending</v-chip>
            </div>

            <div v-if="activeResolveItem === item.name">
                <v-divider />
                <v-card-text>
                <v-text-field
                    v-model="resolveSearchInputs[item.name]"
                    placeholder="Search by UPC or name..."
                    outlined dense hide-details clearable
                    class="mb-3"
                    :loading="resolveSearchLoading[item.name]"
                    @input="searchResolveProduct(item.name)"
                    @keyup.enter="searchResolveProduct(item.name)"
                />

                <v-row dense v-if="resolveCandidates[item.name] && resolveCandidates[item.name].length">
                    <v-col v-for="match in resolveCandidates[item.name]" :key="match.id" cols="12" sm="6" md="4">
                    <v-card
                        outlined
                        class="pa-3 d-flex flex-column align-center text-center cursor-pointer"
                        :style="resolveDecisions[item.name] && resolveDecisions[item.name].product_id === match.id
                        ? 'border-color: #4caf50;' : ''"
                        @click="resolveSelectMatch(item, match)"
                    >
                        <v-avatar size="56" rounded class="mb-2">
                        <SecureImage v-if="match.thumbnail" :src="match.thumbnail" contain />
                        <v-icon v-else size="32" color="grey lighten-1">{{ icons.mdiPackageVariant }}</v-icon>
                        </v-avatar>
                        <div class="text-body-2 font-weight-medium">{{ match.name }}</div>
                        <div class="text-caption grey--text">{{ match.barcode }}</div>
                        <div class="text-caption">{{ match.brand }}</div>
                        <v-btn
                        x-small outlined class="mt-2"
                        :color="resolveDecisions[item.name] && resolveDecisions[item.name].product_id === match.id
                            ? 'success' : 'primary'"
                        @click.stop="resolveSelectMatch(item, match)"
                        >
                        {{ resolveDecisions[item.name] && resolveDecisions[item.name].product_id === match.id
                            ? '✓ Confirmed' : 'Confirm' }}
                        </v-btn>
                    </v-card>
                    </v-col>
                </v-row>

                <v-alert v-else type="info" dense text>
                    No matches found. Try searching above.
                </v-alert>
                <v-divider class="my-3" />
                <div class="text-subtitle-2 mb-2">Enter or correct UPC manually</div>
                <v-row dense>
                <v-col cols="12" sm="4">
                    <v-text-field
                    v-model="manualUPC[item.name]"
                    label="UPC / EAN"
                    outlined dense hide-details
                    @keyup.enter="searchManualUPC(item)"
                    />
                </v-col>
                <v-col cols="12" sm="4" v-if="manualSearchDone[item.name] && !resolveCandidates[item.name].length">
                    <v-text-field
                    v-model="manualName[item.name]"
                    label="Product name"
                    outlined dense hide-details
                    />
                </v-col>
                <v-col cols="12" sm="4" v-if="manualSearchDone[item.name] && !resolveCandidates[item.name].length">
                <v-combobox
                    v-model="manualBrand[item.name]"
                    :items="brandOptions"
                    :loading="brandLoading"
                    item-text="name"
                    item-value="id"
                    label="Brand"
                    outlined dense hide-details
                    return-object
                    hint="Select existing or type to create new"
                />
            </v-col>
            <v-col cols="12" sm="4" v-if="manualSearchDone[item.name] && !resolveCandidates[item.name].length">
                <v-autocomplete
                    v-model="manualMarket[item.name]"
                    :items="marketOptions"
                    :loading="marketLoading"
                    item-text="name"
                    item-value="id"
                    label="Market"
                    outlined dense hide-details
                />
            </v-col>
                </v-row>

                <div class="d-flex align-center mt-2">
                <v-btn
                    small outlined color="primary" class="mr-2"
                    :loading="resolveSearchLoading[item.name]"
                    :disabled="!manualUPC[item.name] || manualUPC[item.name].length < 4"
                    @click="searchManualUPC(item)"
                >
                    <v-icon left small>{{ icons.mdiMagnify }}</v-icon>
                    Search
                </v-btn>
                <v-btn
                    v-if="manualSearchDone[item.name] && !resolveCandidates[item.name].length"
                    small outlined color="success"
                    :disabled="!manualUPC[item.name] || !manualName[item.name] || !manualBrand[item.name]"
                    :loading="manualCreateLoading[item.name]"
                    @click="createAndConfirm(item)"
                >
                <v-icon left small>{{ icons.mdiPlus }}</v-icon>
                Create & confirm
                </v-btn>
                </div>  
                

                <v-alert
                v-if="manualSearchDone[item.name] && !resolveCandidates[item.name].length"
                type="info" dense text class="mt-2"
                >
                No existing product for UPC <strong>{{ manualUPC[item.name] }}</strong>. Enter a name above to create it.
                </v-alert>
                </v-card-text>
            </div>
            </v-card>
        </div>
        </v-card-text>

        <v-card-actions>
        <v-btn text outlined @click="isResolveDialogOpen = false">Cancel</v-btn>
        <v-spacer />
        <v-btn
            color="primary" outlined
            :loading="resolveSubmitting"
            :disabled="!resolveAllDone || resolveSubmitting"
            @click="submitImageResolutions"
        >
            Confirm & Save
        </v-btn>
        </v-card-actions>
    </v-card>
    </v-dialog>
</v-dialog>

</template>

<script>

import { ref, onMounted, watch, computed } from '@vue/composition-api'
import Product from '../product-editor/ProductInfo.vue'
import SecureImage from '../../SecureImage.vue'
import {
    mdiTrayArrowUp,
    mdiPackageVariant,
    mdiPlus
} from '@mdi/js'

import store from '@/store'
import { add } from 'lodash-es'
import useProduct from '../useProduct'

export default {
    components: {
        Product,
        SecureImage
    },
    props:{
        isProductBulkDialog: {
            type: Boolean,
            required:true
        }
    },
    setup(props, {emit}) {
        const imageSides = ref([
            {value:1, text:'FRONT'},
            {value:2, text:'BACK'},
            {value:3, text:'TOP'},
            {value:4, text:'BOTTOM'},
            {value:5, text:'LEFT'},
            {value:8, text:'RIGHT'},
            {value:11, text:'DETAIL'},
            {value:12, text:'OTHER'}])
        const fileData = ref([])
        const saveLoader = ref(false)
        const warning = ref('')
        const editDialog = ref(false)

        const product = ref({})

        const {
            addBulkProductImages,
            loadProductData,
            addProduct,
            brandOptions,
            brandLoading,
            fetchBrands,
            addBrand,
            marketOptions,
            marketLoading,
            fetchMarkets
        } = useProduct()


        const isResolveDialogOpen = ref(false)
        const needsConfirmationImages = ref([])
        const resolveDecisions = ref({})
        const resolveSearchInputs = ref({})
        const resolveSearchLoading = ref({})
        const resolveCandidates = ref({})
        const activeResolveItem = ref(null)
        const resolveSubmitting = ref(false)

        const manualUPC = ref({})
        const manualBrand = ref({})
        const manualMarket = ref({})
        const manualName = ref({})
        const manualSearchDone = ref({})
        const manualCreateLoading = ref({})

        const searchManualUPC = async (item) => {
            const upc = manualUPC.value[item.name]
            if (!upc || upc.length < 4) return

            resolveSearchLoading.value = { ...resolveSearchLoading.value, [item.name]: true }
            manualSearchDone.value = { ...manualSearchDone.value, [item.name]: false }

            try {
                const results = await store.dispatch('app-skutopia/searchProducts', upc)
                resolveCandidates.value = {
                ...resolveCandidates.value,
                [item.name]: results.map(p => ({
                    id: p.id,
                    barcode: p.barcode,
                    name: p.name,
                    brand: p.brand ? p.brand.name : '',
                    thumbnail: p.images && p.images.length
                    ? p.images.find(i => i.is_current)?.thumbnail || p.images[0].thumbnail
                    : null
                }))
                }
                manualSearchDone.value = { ...manualSearchDone.value, [item.name]: true }
            } catch (e) {
                console.error('Manual UPC search error:', e)
            } finally {
                resolveSearchLoading.value = { ...resolveSearchLoading.value, [item.name]: false }
            }
            }

            const createAndConfirm = async (item) => {
                const upc = manualUPC.value[item.name]
                const name = manualName.value[item.name]
                const brandInput = manualBrand.value[item.name]
                const marketId = manualMarket.value[item.name] 
                if (!upc || !name || !brandInput || !marketId) return 

                manualCreateLoading.value = { ...manualCreateLoading.value, [item.name]: true }
                try {
                    let brandId = null

                    if (typeof brandInput === 'object' && brandInput.id) {
                    brandId = brandInput.id
                    } else {
                    const brandName = (typeof brandInput === 'string' ? brandInput : brandInput.name).trim()
                    const matchedBrand = brandOptions.value.find(
                        b => b.name.toLowerCase() === brandName.toLowerCase()
                    )
                    if (matchedBrand) {
                        brandId = matchedBrand.id
                    } else {
                        const newBrandResponse = await store.dispatch('app-skutopia/addBrand', { name: brandName })
                        brandId = newBrandResponse.data.id
                        await fetchBrands() // refresh dropdown for next use
                    }
                    }

                    const response = await store.dispatch('app-skutopia/addProduct', {
                    barcode: upc,
                    name: name,
                    barcode_type: 'UPC',
                    brand: brandId,
                    market: marketId,
                    })
                    const newProduct = response.data

                    resolveDecisions.value = {
                    ...resolveDecisions.value,
                    [item.name]: {
                        filename: item.name,
                        product_id: newProduct.id,
                        side: item.side,
                    },
                    }

                    const next = needsConfirmationImages.value.find(
                    i => i.name !== item.name && !resolveDecisions.value[i.name]
                    )
                    activeResolveItem.value = next ? next.name : null

                } catch (e) {
                    console.error('Create product error:', e)
                    if (e.response && e.response.data) {
                    console.error('Error details:', e.response.data)
                    }
                } finally {
                    manualCreateLoading.value = { ...manualCreateLoading.value, [item.name]: false }
                }
                }


        const uploadImages = async () => {
        const resp = await addBulkProductImages(fileData)
        switch(resp.status) {
            case 201:
                const data = resp.data

                if (data.needs_confirmation && data.needs_confirmation.length > 0) {
                    needsConfirmationImages.value = data.needs_confirmation.map(item => ({
                        name: item.name,
                        original_barcode: item.original_barcode,
                        side: item.side,
                        matches: item.matches,
                    }))

                    needsConfirmationImages.value.forEach(item => {
                        resolveCandidates.value = {
                            ...resolveCandidates.value,
                            [item.name]: item.matches
                        }
                        resolveSearchInputs.value = {
                            ...resolveSearchInputs.value,
                            [item.name]: item.original_barcode
                        }
                    })

                    activeResolveItem.value = needsConfirmationImages.value[0]?.name || null
                    isResolveDialogOpen.value = true

                    const savedFilenames = (data.saved || []).map(s => s.barcode)
                    const needsConfirmFilenames = needsConfirmationImages.value.map(i => i.name)
                    const warningFilenames = (data.warnings || []).map(w => w.name)

                    fileData.value = fileData.value.filter(f =>
                        needsConfirmFilenames.includes(f.file.name) || warningFilenames.includes(f.file.name)
                    )
                }

                if (data.warnings && data.warnings.length > 0) {
                    warning.value = data.warnings.map(w => ({ image: w.warning }))
                } else if (!data.needs_confirmation || data.needs_confirmation.length === 0) {
                    warning.value = []
                    fileData.value = []
                }
                break;
            case 400:
                warning.value = resp.data
                break;
            default:
                break;
        }
    }

        const init = () => {
            fileData.value = []
            warning.value = []
            saveLoader.value = false
            emit('update:is-product-bulk-dialog', false)
        }

        const checkValueInArrayOfObjects = (array, valueToCheck) => {
            return array.some(obj => Object.values(obj).includes(valueToCheck));
        }

        const getUPC = (str) => {
            const parts = str.split('.');
            if (parts.length < 1) {
                return undefined; // Or handle the case where there's no second-to-last element
            }
            return parts[0];
        }

        const getSecondToLast = (str) => {
            const parts = str.split('.');
            if (parts.length < 2) {
                return undefined; // Or handle the case where there's no second-to-last element
            }
            return parts[parts.length - 2];
        }

        const openFile = () => {
            let input = document.createElement('input');
            input.type = 'file';
            input.multiple = true
            input.accept = 'image/png'
            input.onchange = _ => {
                // you can use this method to get file and perform respective operations
                let files = Array.from(input.files);
                 // --- NEW CODE: LIMIT TO 15 ---
                const MAX_LIMIT = 15;
                
                if (files.length > MAX_LIMIT) {
                    // 1. Alert the user via the warning ref
                    warning.value = [{image:`Maximum limit is ${MAX_LIMIT} images. Only the first ${MAX_LIMIT} have been selected.`}];
                    
                    // 2. Trim the array to the first 15 files
                    files = files.slice(0, MAX_LIMIT);
                } else {
                    // Reset warning if selection is valid
                    warning.value = [];
                }
                // -----------------------------

                fileData.value = []
                
                files.map(file => {
                    const inputFile = {
                        file
                    }
                    let reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                        inputFile.url = reader.result
                        if(getSecondToLast(file.name) != undefined) {
                            inputFile.side = imageSides.value[getSecondToLast(file.name)-1]
                        }
                        fileData.value.push(inputFile)
                    }
                })
            };
            input.click();
        }

        const editProduct = (filename) => {
            const barcode = filename.split(".")[0]
            product.value = {}
            product.value['barcode'] = barcode
            product.value['barcode_type'] = 'UPC'

            editDialog.value = true
        }

        const saveProduct = async (sku) => {
            // const sku = JSON.parse(JSON.stringify(product.value))
            const resp = await addProduct(sku)
            editDialog.value = false
            warning.value = [{image:`Product ${sku.barcode} added successfully! Click Upload Images!`}]
        }

        const resolveConfirmations = computed(() => Object.keys(resolveDecisions.value))
        const resolveAllDone = computed(() =>
        resolveConfirmations.value.length === needsConfirmationImages.value.length &&
        needsConfirmationImages.value.length > 0
        )

        const toggleResolveItem = (filename) => {
        activeResolveItem.value = activeResolveItem.value === filename ? null : filename
        }

        const resolveSelectMatch = (item, match) => {
        if (
            resolveDecisions.value[item.name] &&
            resolveDecisions.value[item.name].product_id === match.id
        ) {
            const updated = { ...resolveDecisions.value }
            delete updated[item.name]
            resolveDecisions.value = updated
            return
        }

        resolveDecisions.value = {
            ...resolveDecisions.value,
            [item.name]: {
            filename: item.name,
            product_id: match.id,
            side: item.side,
            },
        }

        const next = needsConfirmationImages.value.find(
            i => i.name !== item.name && !resolveDecisions.value[i.name]
        )
        activeResolveItem.value = next ? next.name : null
        }

        let searchDebounceTimer = null
        const searchResolveProduct = (filename) => {
        const query = resolveSearchInputs.value[filename]
        if (!query || query.length < 3) return

        clearTimeout(searchDebounceTimer)
        searchDebounceTimer = setTimeout(async () => {
            resolveSearchLoading.value = { ...resolveSearchLoading.value, [filename]: true }
            try {
            const results = await store.dispatch('app-skutopia/searchProducts', query)
            resolveCandidates.value = {
                ...resolveCandidates.value,
                [filename]: results.map(p => ({
                id: p.id,
                barcode: p.barcode,
                name: p.name,
                brand: p.brand ? p.brand.name : '',
                thumbnail: p.images && p.images.length
                    ? p.images.find(i => i.is_current)?.thumbnail || p.images[0].thumbnail
                    : null
                }))
            }
            } catch (e) {
            console.error('Search error:', e)
            } finally {
            resolveSearchLoading.value = { ...resolveSearchLoading.value, [filename]: false }
            }
        }, 400)
        }

        const submitImageResolutions = async () => {
        resolveSubmitting.value = true
        try {
            const confirmations = Object.values(resolveDecisions.value)

            const formData = new FormData()
            needsConfirmationImages.value.forEach(item => {
            const originalFile = fileData.value.find(f => f.file.name === item.name)
            if (originalFile) {
                formData.append('images', originalFile.file)
            }
            })
            formData.append('confirmations', JSON.stringify(confirmations))

            const response = await store.dispatch('app-skutopia/confirmImageUpload', formData)

            isResolveDialogOpen.value = false
            needsConfirmationImages.value = []
            resolveDecisions.value = {}

            const resolvedFilenames = confirmations.map(c => c.filename)
            fileData.value = fileData.value.filter(f => !resolvedFilenames.includes(f.file.name))

            warning.value = [{ image: `${response.data.saved.length} image(s) linked successfully.` }]

        } catch (e) {
            console.error('Resolve images error:', e)
        } finally {
            resolveSubmitting.value = false
        }
        }

        onMounted(() => {
            fetchBrands()
            fetchMarkets()
        })


        return {
            saveLoader,
            init,
            uploadImages,
            imageSides,
            fileData,
            loadProductData,
            openFile,
            warning,
            editDialog,
            editProduct,
            product,
            saveProduct,
            isResolveDialogOpen,
            needsConfirmationImages,
            resolveDecisions,
            resolveSearchInputs,
            resolveSearchLoading,
            resolveCandidates,
            activeResolveItem,
            resolveSubmitting,
            resolveConfirmations,
            resolveAllDone,
            toggleResolveItem,
            resolveSelectMatch,
            searchResolveProduct,
            submitImageResolutions,
            manualUPC,
            manualBrand,
            manualMarket,   
            marketLoading,
            marketOptions,
            searchManualUPC,
            manualName,
            manualSearchDone,
            manualCreateLoading,
            createAndConfirm,
            brandLoading,
            brandOptions,
            addBrand,

            icons: {
                mdiTrayArrowUp,
                mdiPackageVariant,
                mdiPlus
            }
        }
    }

}
</script>

<style>

.drop-zone {
  border: 1px dashed rgba(var(--v-theme-on-surface), var(--v-border-opacity));
}
</style>